export const applyFilters = (
  data: any[],
  searchTerm: string,
  filterFunction: (
    item: any,
    searchTerm: string,
    filters: Record<string, string | undefined>,
  ) => boolean,
  filters?: Record<string, string | undefined>,
): any[] => {
  const searchTermLowerCase = searchTerm.toLowerCase();
  if (
    !searchTermLowerCase &&
    filters &&
    Object.values(filters).every((value) => !value)
  ) {
    return data;
  }
  return data.filter(
    (item) => filters && filterFunction(item, searchTermLowerCase, filters),
  );
};
